<template>
    <div class="payment-form">
        <div :id="'card-element-' + _uid" class="card-element"></div>
        <div :id="'card-errors-' + _uid" class="card-errors" role="alert"></div>
    </div>
</template>
<script>
    export default {

        props: {
            url: {
                type: String,
                required: true,
            },
            payload:{
                type: Object,
                required: false,
                default: () => ({})
            },
            redirect:{
                type: String,
                required: false,
                default: '',
            }
        },

        data(){
            return {
                canSubmit: false,
                stripe: null,
                elements: null,
                card: null,
            }
        },

        created(){
            this.stripe = Stripe(App.config.stripeKey);
            App.bus.$on('submit-payment-form', this.submit);
        },

        mounted() {
            this.createElements()
        },

        methods: {

            submit() {
                this.stripe.createToken(this.card).then(result => {
                    if (result.error) {
                        var errorElement = document.getElementById('card-errors-' + this._uid);
                        errorElement.textContent = result.error.message;
                        this.$emit('on-declined');
                    } else {
                        this.card.clear()
                        this.$emit('on-accepted', result.token.id);
                    }
                });
            },

            createElements() {
                this.elements = this.stripe.elements();
                var style = {
                    base: {
                        color: '#32325d',
                        lineHeight: '18px',
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#aab7c4'
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                };
                this.card = this.elements.create('card', {style});

                this.card.mount('#card-element-' + this._uid);

                this.card.addEventListener('change', event => {
                    var displayError = document.getElementById('card-errors-' + this._uid);
                    if (event.error) {
                        displayError.textContent = event.error.message;
                        this.canSubmit = false;
                    } else {
                        this.canSubmit = true;
                        displayError.textContent = '';
                    }
                });

            }
        },

    }
</script>